import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Card,
	CardContent,
	CardActions,
	Grid,
	Collapse,
	Button,
	RootRef,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	card: {
		backgroundColor: theme.palette.secondary.warningYellow
	},

	icon: {
		fontSize: "1.5rem",
		//color: "rgba(0, 0, 0, 0.35)",
		marginRight: theme.spacing(1.5)
	},

	content: {
		display: "flex",
		alignItems: "center",

		"&:last-child": {
			[theme.breakpoints.down('xs')]: {
				paddingBottom: theme.spacing(2)
			},

			[theme.breakpoints.up('sm')]: {
				paddingTop: theme.spacing(3)
			}
		}
	},

	actions: {
		justifyContent: "flex-end",
		paddingRight: theme.spacing(2),

		[theme.breakpoints.up('sm')]: {
			paddingTop: 16
		}
	}
}));

function Banner(props) {
	let classes = styles(),
		{show, icon, content, actions, className, gridClassName, contentClassName, actionsClassName,
			bannerRef, onEntering, onEntered, onExiting, onExited} = props;

	return (
		<RootRef rootRef={bannerRef}>
			<Collapse
				in={show}
				onEntering={onEntering}
				onEntered={onEntered}
				onExiting={onExiting}
				onExited={onExited}>
				<Card
					elevation={2}
					square={true}
					className={`${show ? classes.card : ""} ${className}`}>
					<Grid container alignItems="center" className={gridClassName}>
						<Grid item xs={12} sm={9}>
							<CardContent classes={{root: `${classes.content} ${contentClassName}`}}>
								{icon ? (
									<FontAwesomeIcon
										icon={icon.icon}
										size={icon.size}
										title={icon.title}
										className={`${classes.icon} ${icon.className}`} />
								) : null}
								<Typography aria-disabled="false" tabIndex={0}>{content}</Typography>
							</CardContent>
						</Grid>
						<Grid item xs={12} sm={3}>
							<CardActions classes={{root: `${classes.actions} ${actionsClassName}`}}>
								{actions ? actions.map(action =>
									<Button
										size="small"
										key={action.text}
										color={action.color}
										variant={action.variant}
										onClick={action.handler}>{action.text}</Button>
								) : null}
							</CardActions>
						</Grid>
					</Grid>
				</Card>
			</Collapse>
		</RootRef>
	);
}

Banner.propTypes = {
	show: PropTypes.bool,
	icon: PropTypes.object,
	content: PropTypes.string,
	actions: PropTypes.array,
	className: PropTypes.string,
	gridClassName: PropTypes.string,
	contentClassName: PropTypes.string,
	actionsClassName: PropTypes.string,
	bannerRef: PropTypes.object.isRequired,
	onEntering: PropTypes.func,
	onEntered: PropTypes.func,
	onExiting: PropTypes.func,
	onExited: PropTypes.func,
};

export default Banner;
